<template>
  <!-- eslint-disable max-len -->
  <div class="bpc-table-members">
      <bpc-table-header :fields="fields" :filters="filters" :pagination="pagination"></bpc-table-header>
      <b-table class="table-lg" show-empty
               stacked="md"
               :items="items"
               :fields="fields"
               :current-page="pagination.currentPage"
               :per-page="pagination.perPage"
               :filter="filter"
               :sort-by.sync="pagination.sortBy"
               :sort-desc.sync="pagination.sortDesc"
               :sort-direction="pagination.sortDirection"
               @filtered="onFiltered"
      >
        <template v-slot:head(check)>
          <div class="custom-checkbox custom-control">
            <input type="checkbox" id="exampleCustomCheckbox12" class="custom-control-input">
            <label class="custom-control-label" for="exampleCustomCheckbox12">&nbsp;</label>
          </div>
        </template>
        <template v-slot:cell(check)="row">
          <div class="custom-checkbox custom-control">
            <input type="checkbox" id="exampleCustomCheckbox12" class="custom-control-input" v-model="row.value">
            <label class="custom-control-label" for="exampleCustomCheckbox12">&nbsp;</label>
          </div>
        </template>
        <template v-slot:cell(img_url)="row">
          <div class="avatar-icon-wrapper _avatar-icon-sm"><div class="avatar-icon"><img :src="row.value" alt=""></div></div>
        </template>
        <template v-slot:cell(name)="row">
          {{ row.value.first }} {{ row.value.last }}
        </template>
        <template v-slot:cell(birthdate)="row">
          {{ row.value.date }} <span v-if="row.value.age">({{ row.value.age }})</span>
        </template>
        <template v-slot:cell(status)="row">
          <div v-if="row.value == 'inactive'" class="badge badge-pill badge-danger">Inactive</div>
          <div v-if="row.value == 'active'" class="badge badge-pill badge-success">Active</div>
        </template>
        <!-- <template v-slot:cell(isActive)="row">{{row.value?'Yes :)':'No :('}}</template> -->
        <template v-slot:cell(actions)>
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <!-- <b-button size="sm" @click.stop="row.toggleDetails">
            {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
          </b-button> -->
          <!-- <button type="button" class="btn btn-sm btn-info">
            <font-awesome-icon icon="edit"/>
          </button>
          <button type="button" class="ml-2 btn btn-sm btn-danger">
            <font-awesome-icon icon="trash"/>
          </button>
          <button type="button" class="ml-2 btn btn-sm btn-secondary">
            <font-awesome-icon icon="ellipsis-h"/>
          </button> -->
          <b-button-group>
            <b-button variant="outline-link" class="border-0 btn-transition">
              <!-- <font-awesome-icon icon="edit"/> -->
              <i class="vsm-icon pe-7s-note"></i>
            </b-button>
            <b-button variant="outline-link" class="border-0 btn-transition">
              <!-- <font-awesome-icon icon="trash"/> -->
              <i class="vsm-icon pe-7s-trash"></i>
            </b-button>
            <b-button variant="outline-link" class="border-0 btn-transition">
              <!-- <font-awesome-icon icon="ellipsis-h"/> -->
              <i class="vsm-icon pe-7s-angle-down"></i>
            </b-button>
          </b-button-group>
        </template>
        <template slot="row-details" slot-scope="row">
          <b-card class="no-shadow">
            <ul class="list-group">
              <li class="list-group-item" v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li>
            </ul>
          </b-card>
        </template>
      </b-table>
      <bpc-table-footer :pagination="pagination"></bpc-table-footer>

  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faStar,
  faPlus,
  faTrash,
  faPlay,
  faForward,
  faRocket,
  faQuestion,
  faEdit,
  faEllipsisH,
} from '@fortawesome/free-solid-svg-icons';


import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BpcTableHeader from '@/mockups/layouts/components/BpcTableHeader.vue';
import BpcTableFooter from '@/mockups/layouts/components/BpcTableFooter.vue';

import avatar1 from '../assets/avatars/1.jpg';
import avatar2 from '../assets/avatars/2.jpg';
import avatar3 from '../assets/avatars/3.jpg';
import avatar4 from '../assets/avatars/4.jpg';
import avatar5 from '../assets/avatars/5.jpg';
import avatar6 from '../assets/avatars/6.jpg';
import avatar7 from '../assets/avatars/7.jpg';
import avatar8 from '../assets/avatars/8.jpg';
import avatar9 from '../assets/avatars/9.jpg';
import avatar10 from '../assets/avatars/10.jpg';

library.add(
  faStar,
  faPlus,
  faTrash,
  faPlay,
  faForward,
  faRocket,
  faQuestion,
  faEdit,
  faEllipsisH,
);

const items = [
  {
    check: null,
    birthdate: { date: '1979-08-24', age: 40 },
    type: 'Individual',
    status: 'active',
    name: { first: 'Dickerson', last: 'Macdonald' },
    img_url: avatar1,
  },
  {
    check: null,
    birthdate: { date: '1998-10-15', age: 21 },
    type: 'Individual',
    status: 'active',
    name: { first: 'Larsen', last: 'Shaw' },
    img_url: avatar2,
  },
  {
    check: false,
    birthdate: { date: null, age: null },
    type: 'School',
    status: 'inactive',
    name: { first: 'High School V', last: '' },
    img_url: avatar3,
    // _rowVariant: 'success',
  },
  {
    check: null,
    birthdate: { date: null, age: null },
    type: 'Company',
    status: 'active',
    name: { first: 'Google', last: '' },
    img_url: avatar8,
  },
  {
    check: null,
    birthdate: { date: null, age: null },
    type: 'Club',
    status: 'active',
    name: { first: 'Speedy MSG', last: '' },
    img_url: avatar9,
  },
  {
    check: null,
    birthdate: { date: '1979-08-24', age: 40 },
    type: 'Individual',
    status: 'active',
    name: { first: 'Essie', last: 'Dunlap' },
    img_url: avatar4,
  },
  {
    check: null,
    birthdate: { date: '1957-07-23', age: 63 },
    type: 'Individual',
    status: 'active',
    name: { first: 'Thor', last: 'Macdonald' },
    img_url: avatar5,
  },
  {
    check: false,
    birthdate: { date: null, age: null },
    type: 'Club',
    status: 'inactive',
    name: { first: 'Tennis Club', last: '' },
    img_url: avatar6,
    // _cellVariants: { age: 'danger', isActive: 'warning' },
  },
  {
    check: null,
    birthdate: { date: '2004-12-11', age: 16 },
    type: 'Individual',
    status: 'active',
    name: { first: 'Mitzi', last: 'Navarro' },
    img_url: avatar7,
  },
  {
    check: null,
    birthdate: { date: '2008-05-30', age: 12 },
    type: 'Individual',
    status: 'active',
    name: { first: 'Genevieve', last: 'Wilson' },
    img_url: avatar8,
  },
  {
    check: null,
    birthdate: { date: '1981-03-02', age: 38 },
    type: 'Individual',
    status: 'active',
    name: { first: 'John', last: 'Carney' },
    img_url: avatar9,
  },
  {
    check: null,
    birthdate: { date: '1990-08-14', age: 29 },
    type: 'Individual',
    status: 'inactive',
    name: { first: 'Dick', last: 'Dunlap' },
    img_url: avatar10,
  },
];

export default {
  components: {
    // 'font-awesome-icon': FontAwesomeIcon,
    BpcTableHeader,
    BpcTableFooter,
  },
  data: () => ({
    header: {
      heading: 'Members',
      subheading: 'Members of your sport center',
      icon: '', // 'pe-7s-users icon-gradient bg-tempting-azure',
      breadcrumb: ['Dashboard', 'Members'],
      links: ['Help', 'Settings'],
      actions: {
        delete: true, bulk: true, new: true, edit: false, actions: true,
      },
    },
    filters: ['search', 'status', 'type'],
    pagination: {
      currentPage: 1,
      perPage: 5,
      totalRows: items.length,
      pageOptions: [5, 10, 20, 50, 100, 200],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
    },
    items,
    fields: [
      {
        key: 'check', label: 'Check', class: 'check',
      },
      {
        key: 'img_url', label: 'Pic', class: 'avatar',
      },
      {
        key: 'name', label: 'Full name', class: 'fullname', sortable: true, sortDirection: 'desc',
      },
      {
        key: 'type', label: 'Type', class: 'type', sortable: true, sortDirection: 'desc',
      },
      {
        key: 'birthdate', label: 'Birthdate (age)', class: 'birthdate', sortable: true,
      },
      {
        key: 'status', label: 'Status', class: 'status', sortable: true, sortDirection: 'desc',
      },
      {
        key: 'actions', label: 'Actions', class: 'actions',
      },
    ],
    filter: null,
    modalInfo: { title: '', content: '' },
  }),
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
  },
  methods: {
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit('bv::show::modal', 'modalInfo', button);
    },
    resetModal() {
      this.modalInfo.title = '';
      this.modalInfo.content = '';
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style>
.card-body {
  padding: 0 !important;
}
.card-title {
  padding: 1.25rem 0.825rem 0.5rem;
}
.card-body table {
  margin-bottom: 0;
}
.card-body table tr:last-child {
  border-bottom: 1px solid #e9ecef;
}
.table thead th {
  background-color: #f3f3f3;
  border-bottom-width: 1px !important;
}
.table td {
  vertical-align: middle;
}
.table th.check, .table td.check {
  width: 40px;
  text-align: center;
}
.table th.avatar {
  width: 50px;
}
.table td.avatar {
  padding: 5px 0 0;
}
.table th.status {
  width: 100px;
}
.table th.actions {
  width: 110px;
}
.table td.actions {
  padding-top: 0.825rem;
  padding-bottom: 0.825rem;
}
.table td.actions .btn {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  width: 30px;
  text-align: center;
  font-size: 1rem;
}
.table td.actions .btn-link:hover {
  background-color: #e9ecef;
  border-radius: 3px;
}
</style>
